import Vue from 'vue';
import Vuex from 'vuex';

import navigation from './modules/navigation';
import table from './modules/table';
import charts from './modules/charts';
import models from './modules/models';
import config from './modules/config';
import dollarQuotation from './modules/dollar-quotation';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    config,
    models,
    dollarQuotation,
    navigation,
    table,
    charts,
  },
});
